import "../../assets/sass/layout/_footer.scss";
import Logofooter from "../../assets/images/logoFooter.png";
const Footer = () => {
  return (
    <div className="footer">
      <img src={Logofooter} alt=" logo kasa"></img>
      <p>© 2020 Kasa. All rights reserved</p>
    </div>
  );
};

export default Footer;
